import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import Footer from "components/Footer/Footer.js";
import ImageGallery from "components/ImageGallery/ImageGallery.js";

export default function OrthopedicCasesPage() {
  React.useEffect(() => {
    document.body.classList.toggle("orthopedic-cases-page");
    return function cleanup() {
      document.body.classList.toggle("orthopedic-cases-page");
    };
  }, []);

  return (
    <>
      <IndexNavbar />
      <div className="wrapper">
        {/* Header de la página */}
        <div className="page-header header-filter section" style={{
          minHeight: "25vh",
          display: "flex",
          alignItems: "center",
          position: "relative"
        }}>
          <div className="squares square1" />
          <div className="squares square3" />
          <Container style={{position: "relative", zIndex: 1}}>
            <Row className="justify-content-center text-center">
              <Col md="8">
                
                <Link to="/">
                  <Button 
                    color="primary" 
                    style={{
                      padding: '10px 30px',
                      marginTop: '20px',
                      borderRadius: '25px',
                      fontWeight: 600,
                      backgroundColor: '#259778',
                      borderColor: '#259778'
                    }}
                  >
                    ← Volver al Inicio
                  </Button>
                </Link>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Sección principal con el álbum embebido */}
        <div className="main">
          <div className="section" style={{
            paddingTop: 5,
            paddingBottom: 80,
            minHeight: '70vh'
          }}>
            <Container>
              <Row className="justify-content-center">
                <Col md="10">
                  {/* Galería de aparatos - Local */}
                  <div style={{
                    backgroundColor: '#ffffff',
                    borderRadius: 20,
                    padding: 30,
                    boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                    marginBottom: 40
                  }}>
                    <ImageGallery />
                  </div>


                  {/* Botón de contacto */}
                  <div className="text-center">
                    <h5 style={{color: '#32325d', marginBottom: 20}}>
                      ¿Ya elegiste el diseño? ¡Agenda tu consulta!
                    </h5>
                    <a 
                      href="https://wa.me/5492996316836?text=Hola! He visto la galería de aparatos de ortopedia y me gustaría agendar una consulta para mi hijo/a."
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{textDecoration: 'none'}}
                    >
                      <Button 
                        color="primary" 
                        size="lg"
                        style={{
                          fontSize: '1.1rem',
                          fontWeight: 600,
                          padding: '15px 40px',
                          borderRadius: '50px'
                        }}
                      >
                        📱 Contactar por WhatsApp
                      </Button>
                    </a>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
        
        <Footer />
      </div>
    </>
  );
}